module.exports = __webpack_public_path__ + "afa08c40cea5d4a4cee46bd1bef3cbbc.MP3";